import { computed, type ComputedRef } from 'vue'

import { useFeatureFlags, useRbac } from '@/features/account'

export interface UseInsightsRbac {
  canViewInsights: ComputedRef<boolean>
  canAuthorInsights: ComputedRef<boolean>
  canUseWorkbench: ComputedRef<boolean>
}

/** Cold-boot-safe gates backed only by server-authored module-07 state. */
export function useInsightsRbac(): UseInsightsRbac {
  const flags = useFeatureFlags()
  const rbac = useRbac()

  return {
    canViewInsights: computed(() => rbac.isSysAdmin.value || flags.checkFlag('insights')),
    canAuthorInsights: computed(() => rbac.isSysAdmin.value),
    canUseWorkbench: computed(() => rbac.isSysAdmin.value),
  }
}
